import React from 'react';

const StepIndicator = ({ totalSteps, currentStep, labels = [] }) => {
	return (
		<div className="flex items-center justify-center mb-8">
			{Array.from({ length: totalSteps }, (_, index) => {
				const stepNumber = index + 1;
				const isCompleted = index < currentStep;
				const isCurrent = index === currentStep;
				const isUpcoming = index > currentStep;

				return (
					<React.Fragment key={index}>
						{/* Step Circle */}
						<div className="flex flex-col items-center">
							<div
								className={`
									w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm
									${isCompleted ? 'bg-brand text-white' : ''}
									${isCurrent ? 'bg-brand/10 text-brand ring-2 ring-brand' : ''}
									${isUpcoming ? 'bg-gray-200 text-gray-400' : ''}
								`}
							>
								{stepNumber}
							</div>
							{labels[index] && (
								<span className="text-xs text-gray-600 mt-2 text-center max-w-[80px]">
									{labels[index]}
								</span>
							)}
						</div>

						{/* Connecting Line */}
						{index < totalSteps - 1 && (
							<div
								className={`
									h-1 w-12 mx-2
									${index < currentStep ? 'bg-brand' : 'bg-gray-200'}
								`}
							/>
						)}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default StepIndicator;
